module.exports = __webpack_public_path__ + "img/4-1_1968f1005.png";